import { render, staticRenderFns } from "./Matching.vue?vue&type=template&id=59ea3640&scoped=true"
import script from "./Matching.vue?vue&type=script&lang=js"
export * from "./Matching.vue?vue&type=script&lang=js"
import style0 from "./Matching.vue?vue&type=style&index=0&id=59ea3640&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ea3640",
  null
  
)

export default component.exports